/* import __COLOCATED_TEMPLATE__ from './phone-call.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const PhoneCall = templateOnlyComponent<Signature>();
export default PhoneCall;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::PhoneCall': typeof PhoneCall;
    'inbox2/conversation-stream/event-parts/phone-call': typeof PhoneCall;
  }
}
